import "./Home.style.css"

// Components
import NavigationBar from "../../Components/NavigationBar"
import Footer from "../../Components/Footer"

// React Bootstrap Icons
import { CarFront, CashCoin, EnvelopeAt, Pen, Whatsapp } from "react-bootstrap-icons"

const PageHome = () => {
    return (
        <>
            <NavigationBar />

            <section id="home" className="home">
                <div className="container">
                    <h1>Solusi Keuangan & Kendaraan Anda</h1>
                    <p>Layanan Penagihan | Jual Beli & Gadai Kendaraan Second | Supplier ATK</p>
                </div>
            </section>

            <section id="about-us" className="about-us">
                <div className="container">
                    <h1>About Us</h1>
                    <p>Kami adalah perusahaan yang bergerak di bidang Penagihan, Jual Beli & Gadai Kendaraan Second, serta Penyedia ATK, dengan fokus memberikan layanan yang cepat, aman, dan profesional. Didukung tim berpengalaman, kami mengutamakan kejujuran dan transparansi dalam setiap proses, sehingga mampu menjadi mitra tepercaya bagi individu, perusahaan, maupun instansi yang membutuhkan solusi layanan yang efisien dan berkualitas.</p>
                    
                    <div className="card-wrapper">
                        <div className="card">
                            <div className="card-icons">
                                <CarFront color="#FFF" />
                            </div>
                            <div className="card-body">
                                <span className="card-counter">150+</span>
                                <span className="card-title">Motor Berhasil Terjual</span>
                            </div>
                        </div>
                        <div className="card">
                            <div className="card-icons">
                                <CarFront color="#FFF" />
                            </div>
                            <div className="card-body">
                                <span className="card-counter">100+</span>
                                <span className="card-title">Mobil Berhasil Terjual</span>
                            </div>
                        </div>
                        <div className="card">
                            <div className="card-icons">
                                <CarFront color="#FFF" />
                            </div>
                            <div className="card-body">
                                <span className="card-counter">250+</span>
                                <span className="card-title">Tagihan Berhasil Ditangani</span>
                            </div>
                        </div>
                        <div className="card">
                            <div className="card-icons">
                                <CarFront color="#FFF" />
                            </div>
                            <div className="card-body">
                                <span className="card-counter">50+</span>
                                <span className="card-title">ATK Berhasil Terdistribusi</span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section id="service" className="service">
                <div className="container">
                    <h1>Our <span>Service</span></h1>

                    <div className="card-wrapper">
                        <div className="card">
                            <div className="card-icons">
                                <CashCoin color="#3B1E54" />
                            </div>
                            <div className="card-body">
                                <span className="card-title">Penagihan</span>
                                <span className="card-text">Layanan penagihan yang profesional, cepat, dan terpercaya untuk menagih pembayaran serta mendukung kelancaran bisnis Anda.</span>
                            </div>
                        </div>
                        <div className="card">
                            <div className="card-icons">
                                <CarFront color="#3B1E54" />
                            </div>
                            <div className="card-body">
                                <span className="card-title">Kenderaan Second</span>
                                <span className="card-text">Melayani jual, beli, dan gadai motor serta mobil bekas dengan proses yang mudah dan terpercaya, memastikan setiap unit dalam kondisi layak dan siap pakai.</span>
                            </div>
                        </div>
                        <div className="card">
                            <div className="card-icons">
                                <Pen color="#3B1E54" />
                            </div>
                            <div className="card-body">
                                <span className="card-title">Supplier ATK</span>
                                <span className="card-text">Menyediakan kebutuhan alat tulis kantor secara lengkap dan terjangkau untuk mendukung kelancaran operasional bisnis, sekolah, maupun instansi.</span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section id="contact" className="contact">
                <div className="container">
                    <h1>Contact</h1>
                    <div className="row contact-wrapper">
                        <div className="col-12 col-lg-6">
                            <iframe 
                                title="PT Irwan Sukses Abadi"
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3989.616628725814!2d123.0898283646665!3d0.576111870784582!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x327ed3006b7b843d%3A0x89ccc0e815ffadba!2sPT%20Irwan%20Sukses%20Abadi!5e0!3m2!1sid!2sid!4v1763049141291!5m2!1sid!2sid"
                                allowfullscreen=""
                                loading="lazy"
                                referrerpolicy="no-referrer-when-downgrade"
                            ></iframe>
                        </div>
                        <div className="col-12 col-lg-6">
                            <h1>PT Irwan Sukses Abadi</h1>
                            <p>Jl. Dulohupa, Kel. Dulomo Utara, Kec. Kota Utara, Kota Gorontalo, Gorontalo 96123</p>
                            <ul>
                                <li>
                                    <Whatsapp />
                                    <a href="https://wa.me/+6285256493007" target="_blank" rel="noreferrer">+62 852 5649 3007</a>
                                </li>
                                <li>
                                    <EnvelopeAt />
                                    <a href="mailto:pt.irwansentosaabadi@gmail.com" target="_blank" rel="noreferrer">pt.irwansentosaabadi@gmail.com</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
        </>
    )
}

export default PageHome